import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { IconButton } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { PushDetails } from '../../types/channelPush'
import useStyles from './styles/accsTableHead.styles'

interface AccsTabelHeadProps {
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      channelPush: PushDetails
    }>
  >
}

const AccsTabelHead: React.FC<AccsTabelHeadProps> = ({ refetch }) => {
  const classes = useStyles()

  return (
    <div className={classes.tableHead}>
      <div>{getTranslate('Name')}</div>
      <div>{getTranslate('Adaptor')}</div>
      <div>{getTranslate('Last Fetched')}</div>
      <div>{getTranslate('Last Sent')}</div>
      <div>{getTranslate('Next Time')}</div>
      <div>{getTranslate('Health Status')}</div>
      <div>
        <IconButton onClick={() => refetch()}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default AccsTabelHead
